import React from "react";
import './SocialMediaBar.css';
import { Link } from "react-router-dom";
import instagramIcon from '../../../assets/instagram-icon.svg';
import tiktokIcon from '../../../assets/tiktok-icon.svg';
import xIcon from '../../../assets/x-icon.svg';
import youtubeIcon from '../../../assets/youtube-icon.svg';
import facebookIcon from '../../../assets/facebook-icon.svg';
import pinterestIcon from '../../../assets/pinterest-icon.svg';
import tumblrIcon from '../../../assets/tumblr-icon.svg';
import openseaIcon from '../../../assets/opensea-black-icon.svg';
import threadsIcon from '../../../assets/threads-icon.png';

const SocialMediaBar = () => {
    return (
        <div className="social-media-bar-wrapper">
          <Link className="social-media-link" to="https://www.instagram.com/colorfuel.art.studio/" target="_blank" rel="noopener noreferrer" title="Instagram">
            <img src={instagramIcon} alt="instagram icon" />
          </Link>
          <Link className="social-media-link" to="https://www.tiktok.com/@colorfuel?lang=en" target="_blank" rel="noopener noreferrer" title="TikTok">
            <img src={tiktokIcon} alt="tiktok icon" />
          </Link>
          <Link className="social-media-link" to="https://twitter.com/ColorFuel_Art" target="_blank" rel="noopener noreferrer" title="X (Twitter)">
            <img src={xIcon} alt="x icon" />
          </Link>
          <Link className="social-media-link" to="https://www.youtube.com/@colorfuel.art.studio" target="_blank" rel="noopener noreferrer" title="YouTube">
            <img src={youtubeIcon} alt="youtube icon" />
          </Link>
          <Link className="social-media-link" to="https://www.facebook.com/profile.php?id=100092966033792" target="_blank" rel="noopener noreferrer" title="Facebook">
            <img src={facebookIcon} alt="facebook icon" />
          </Link>
          <Link className="social-media-link" to="https://no.pinterest.com/colorfuelartstudio/" target="_blank" rel="noopener noreferrer" title="Pinterest">
            <img src={pinterestIcon} alt="pinterest icon" />
          </Link>
          <Link className="social-media-link" to="https://www.tumblr.com/colorfuel-art" target="_blank" rel="noopener noreferrer" title="Tumblr">
            <img src={tumblrIcon} alt="tumblr icon" />
          </Link>
          <Link className="social-media-link" to="https://www.threads.net/@colorfuel.art.studio" target="_blank" rel="noopener noreferrer" title="Threads">
            <img src={threadsIcon} alt="threads icon" />
          </Link>
          <Link className="social-media-link" to="https://opensea.io/colorfuel_art_studio" target="_blank" rel="noopener noreferrer" title="OpenSea">
            <img src={openseaIcon} alt="opensea icon" />
          </Link>
        </div>
    );
}

export default SocialMediaBar;
